import { ColDef, ColGroupDef, ValueGetterParams } from 'ag-grid-community';

// Helper Functions
import { formatImportDate } from '../PreOrders/Utils';

interface IItemImportColumnDefinitions {
  itemGroupGetter: (params: ValueGetterParams) => any;
}

export const getItemImportColumnDefinitions = ({
  itemGroupGetter,
}: IItemImportColumnDefinitions) => {
  const itemImportColsDef: Array<ColDef | ColGroupDef> = [
    {
      headerName: 'Row',
      headerClass: 'px-import-review-header',
      children: [
        {
          valueGetter: itemGroupGetter,
          rowGroup: true,
          hide: true,
        },
        {
          headerName: '',
          field: 'rowNumber',
          minWidth: 50,
          maxWidth: 80,
        },
      ],
    },
    {
      headerName: 'Draft Items',
      headerClass: 'px-import-review-header',
      children: [
        {
          headerName: 'Item#',
          colId: 'itemNumber',
          field: 'itemNumber',
          valueGetter: (params: ValueGetterParams) => {
            return params?.data?.itemNumber ?? '--';
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          headerName: 'Warehouse',
          field: 'warehouse',
          colId: 'warehouse',
          cellClass: 'po-import-longtext',
          wrapText: true,
          valueGetter: (params: ValueGetterParams) => {
            return params?.data?.warehouse ?? '--';
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          headerName: 'Quantity Forecast',
          field: 'quantityForecast',
          colId: 'quantityForecast',
          wrapText: true,
          valueGetter: (params: ValueGetterParams) => {
            return params?.data?.quantityForecast ?? '--';
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          headerName: 'Description',
          colId: 'dbItemDescription',
          field: 'dbItemDescription',
          cellClass: 'po-import-longtext',
          wrapText: true,
          minWidth: 125,
          maxWidth: 350,
        },
        {
          headerName: 'Offer Start Date',
          field: 'offerStartDate',
          colId: 'offerStartDate',
          wrapText: true,
          valueGetter: (params: ValueGetterParams) => {
            return formatImportDate(params?.data?.offerStartDate);
          },
          minWidth: 125,
          maxWidth: 200,
        },
        {
          headerName: 'Offer End Date',
          field: 'offerEndDate',
          colId: 'offerEndDate',
          wrapText: true,
          valueGetter: (params: ValueGetterParams) => {
            return formatImportDate(params?.data?.offerEndDate);
          },
          minWidth: 125,
          maxWidth: 200,
        },
        {
          headerName: 'Shipping Start Date',
          field: 'shippingStartDate',
          colId: 'shippingStartDate',
          wrapText: true,
          valueGetter: (params: ValueGetterParams) => {
            return formatImportDate(params?.data?.shippingStartDate);
          },
          minWidth: 125,
          maxWidth: 200,
        },
        {
          headerName: 'Shipping End Date',
          field: 'shippingEndDate',
          colId: 'shippingEndDate',
          wrapText: true,
          valueGetter: (params: ValueGetterParams) => {
            return formatImportDate(params?.data?.shippingEndDate);
          },
          minWidth: 125,
          maxWidth: 200,
        },
      ],
    },
  ];

  return itemImportColsDef;
};
